


















































import { Mixins, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import MixinAncesstors from 'src/components/presenter/item/MixinAncesstors'

@Component
export default class PresenterLayoutMenuButtonBack extends Mixins(MixinAncesstors) {
  me = store.state.person

  get item () {
    return store.state.presenter.item!
  }

  get backTo () {
    if (this.$route.name === 'student' ) {
      return '/presenter/' + this.item.id + '/students'
    } else if (this.$route.name === 'forum-topic' ) {
      return '/presenter/' + this.item.id + '/forum'
    } else if (this.$route.name !== 'content' && this.$route.name !== 'share') {
      return '/presenter/' + this.item.id
    } else if (this.parent) {
      return '/presenter/' + this.parent.id
    } else if (this.item?.ownerPublicProfile && this.item.ownerPublicProfile.personId !== this.me.id) {
      return '/presenter/share/' + this.item.ownerPublicProfile.personId
    } else {
      return '/presenter/'
    }
  }
}
